module.exports = __webpack_public_path__ + "img/covid.b68e5933.png";